import { render, staticRenderFns } from "./wave_response.vue?vue&type=template&id=21b36334&scoped=true"
import script from "./wave_response.vue?vue&type=script&lang=js"
export * from "./wave_response.vue?vue&type=script&lang=js"
import style0 from "./wave_response.vue?vue&type=style&index=0&id=21b36334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b36334",
  null
  
)

export default component.exports